import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { getAuth } from 'firebase/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "configuratore" */ '../views/ConfiguratoreSedute.vue')
  },
  {
    path: '/sign-in',
    name: 'sign in',
    component: () => import(/* webpackChunkName: "sign in" */ '../views/SignIn.vue'),
    beforeEnter: (to, from, next) => {
      const auth = getAuth()
      const user = auth.currentUser
      if (user) {
        next('/backend') // già loggato → backend
      } else {
        next() // mostra login
      }
    }
  },
  {
    path: '/backend',
    name: 'backend',
    component: () => import(/* webpackChunkName: "sign in" */ '../views/BackendPage.vue'),
    beforeEnter: (to, from, next) => {
      const auth = getAuth()
      const user = auth.currentUser
      if (user) {
        next() // accesso consentito
      } else {
        next('/sign-in') // non loggato → login
      }
    },
    children: [
      {
        path: 'databases',
        name: 'databases',
        component: () => import(/* webpackChunkName: "sign in" */ '../views/DatabasesList.vue'),
        beforeEnter: (to, from, next) => {
          const auth = getAuth()
          const user = auth.currentUser
          if (user) {
            next()
          } else {
            next('/sign-in')
          }
        },
        children: [
          {
            path: 'modelli',
            name: 'models-database',
            component: () => import('../views/ModelsDatabaseView.vue')
          },
          {
            path: 'modelCombinations',
            name: 'model-combinations-database',
            component: () => import('../views/ModelsCombinationsDatabaseView.vue')
          },
          {
            path: 'materials',
            name: 'materials-database',
            component: () => import('../views/MaterialsDatabaseView.vue')
          },
          {
            path: 'optional',
            name: 'optionals-database',
            component: () => import('../views/OptionalsDatabaseView.vue')
          },
          {
            path: 'optionalCombinations',
            name: 'optionals-combinations-database',
            component: () => import('../views/OptionalsCombinationsDatabaseView.vue')
          },
          {
            path: 'certifications',
            name: 'certifications-database',
            component: () => import('../views/CertificationsDatabaseView.vue')
          },
          {
            path: 'certificationCombinations',
            name: 'certifications-combinations-database',
            component: () => import('../views/CertificationsCombinationsDatabaseView.vue')
          }
        ]
      },
            {
        path: 'media',
        name: 'media',
        component: () => import(/* webpackChunkName: "sign in" */ '../views/MediaLibraryView.vue'),
        beforeEnter: (to, from, next) => {
          const auth = getAuth()
          const user = auth.currentUser
          if (user) {
            next()
          } else {
            next('/sign-in')
          }
        }
      },
            {
        path: 'settings',
        name: 'settings',
        component: () => import(/* webpackChunkName: "sign in" */ '../views/SettingsList.vue'),
        beforeEnter: (to, from, next) => {
          const auth = getAuth()
          const user = auth.currentUser
          if (user) {
            next()
          } else {
            next('/sign-in')
          }
        },
        children: [
          {
            path: 'guide',
            name: 'guide',
            component: () => import('../views/GuideView.vue')
          },
          {
            path: 'configurator-settings',
            name: 'configurator-settings',
            component: () => import('../views/ConfiguratorSettingsView.vue')
          },
          {
            path: 'optional-order',
            name: 'optional-order',
            component: () => import('../views/OptionsOrderingView.vue')
          },
          {
            path: 'roadmap',
            name: 'roadmap',
            component: () => import('../views/RoadmapView.vue')
          },
          {
            path: 'changelog',
            name: 'changelog',
            component: () => import('../views/ChangelogList.vue')
          }
        ]
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
